/**
 * Created by Jerker Nord on 2019-03-12.
 */
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {BuffaloWinlinesView} from "./BuffaloWinlinesView";
import {Timeline } from "gsap";
import {WinterHoardParsedInitData} from "../../server/data/IWinterHoardServerData";
export class AnimatedWinlines {

    public static readonly PLAY_ANIMATED_WINLINE:string = "AnimatedWinlinesView_playAnimatedWinline";
    public static readonly CLEAN_UP_ANIMATED_WINLINE:string = "AnimatedWinlinesView_cleanUpAnimatedWinline";
    private _view:BuffaloWinlinesView;

    constructor() {
        this._view = new BuffaloWinlinesView();
        this.addEventListeners();
    }

    public disableBetlineNumbers():void {
        this._view.disableBetlineNumbers();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        //EventHandler.addEventListener(this, AnimatedWinlines.PLAY_ANIMATED_WINLINE, (event:GameEvent):void => this.playAnimatedWinline(event.params[0]));
        //EventHandler.addEventListener(this, AnimatedWinlines.CLEAN_UP_ANIMATED_WINLINE, (event:GameEvent):void => this.cleanUpAnimatedWinlines());
    }

    private onInitDataParsed(data:WinterHoardParsedInitData):void {
        this._view.betLinesData = data.betLines;
    }

    public playAnimatedWinline(winLine:number, winVal:string):Timeline {
        return this._view.getWinlineTL(winLine, winVal);
    }

    public cleanUpAnimatedWinlines():Timeline {
        return this._view.getCleanUpWinlinesTL();
    }
}